/**
 * @fileOverview Utilities for authorities-client to traverse class hierarchies
 */

function _flatten(hierarchy, parentName, listOfParents=[], ancestors={}, descendants={}) {
    if (typeof hierarchy === 'object') {
        for (let k in hierarchy) {
            descendants[k] = descendants[k] || []
            let listOfParentsClone = [...listOfParents]
            if (parentName) listOfParentsClone.unshift(parentName)
            // XXX recursion here
            _flatten(hierarchy[k], k, listOfParentsClone, ancestors, descendants)
            ancestors[k] = listOfParentsClone
            for (let k2 of listOfParentsClone) {
                descendants[k2].push(k)
            }
        }
    }
    return {_ancestors: ancestors, _descendants: descendants}
}

module.exports = class HierarchyUtils {

    /**
     * #### new HierarchyUtils(hierarchy)
     * 
     * `@param {object} hierarchy`  key is class name, if value is object: nested, otherwise leaf node
     */
    constructor(hierarchy) {
        this.hierarchy = hierarchy        
        Object.assign(this, _flatten(hierarchy))
        this._classes = Object.keys(this._ancestors)
    }

    _validType(type) {
        if (!(type in this._ancestors)) throw new Error(type + ' not in class hierarchy')
    }

    descendants(type) {
        this._validType(type)
        return [...this._descendants[type]]
    }

    ancestors(type) {
        this._validType(type)
        return [...this._ancestors[type]]
    }

    descendantsOrSelf(type) {
        this._validType(type)
        return [type, ...this._descendants[type]]
    }

    ancestorsOrSelf(type) {
        this._validType(type)
        return [type, ...this._ancestors[type]]
    }

    all() {
        return [...this._classes]
    }

    count() {
        return this._classes.length
    }
}
